/**
 * Stable CSS class names for E2E — Gift vouchers (customer management).
 */
export const GV = {
    page: 'gift-vouchers-page',
    inputButtonAdd: 'gift-voucher-input--button-add',
    sortBar: 'gift-vouchers-page__sort-bar',
    inputSelectSortKey: 'gift-voucher-input--select-sort-key',
    inputSelectSortDirection: 'gift-voucher-input--select-sort-direction',

    gridSection: 'gift-vouchers-page__grid-section',
    table: 'gift-vouchers-page__table',
    inputIconButtonRowMenu: 'gift-voucher-input--icon-button-row-menu',
    inputMenuItemEdit: 'gift-voucher-input--menu-item-edit',
    inputMenuItemDelete: 'gift-voucher-input--menu-item-delete',
    tablePagination: 'gift-vouchers-page__table-pagination',

    drawerBody: 'gift-voucher-drawer__body',
    drawerTitle: 'gift-voucher-drawer__title',
    drawerForm: 'gift-voucher-drawer__form',
    fieldDateRange: 'gift-voucher-field--date-range',
    fieldStatus: 'gift-voucher-field--status',
    inputSelectStatus: 'gift-voucher-input--select-status',
    fieldLanguageRow: 'gift-voucher-field--language-row',
    inputTextfieldLanguage: 'gift-voucher-input--textfield-language',
    fieldDescription: 'gift-voucher-field--description',
    inputTextfieldDescription: 'gift-voucher-input--textfield-description',
    fieldSaleType: 'gift-voucher-field--sale-type',
    inputRadioGroupSaleType: 'gift-voucher-input--radio-group-sale-type',
    inputTextfieldValue: 'gift-voucher-input--textfield-value',
    inputTextfieldMaxAmount: 'gift-voucher-input--textfield-max-amount',
    inputTextfieldMinAmount: 'gift-voucher-input--textfield-min-amount',
    inputButtonSave: 'gift-voucher-input--button-save',
} as const;

export const gvCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
